// React Component (or JSX)

import React from 'react';
import './App.css'; // Assuming you have a CSS file for styles

const MatthewRocklinPR_pytorch_pytorch_issues_9168_From_2018_7_01_To_2018_8_31 = () => {
  return (
    <>
     <a
        href="https://github.com/mrocklin?tab=overview&from=2018-07-01&to=2018-07-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Overview of commits/PRs from Jul 1, 2018 to Jul 31, 2018
      </a>
<div>
<a
        href="https://github.com/mrocklin?tab=overview&from=2018-07-01&to=2018-07-31"
        target="_blank"
        rel="noopener noreferrer"
      >
        Backend URL Link  https://github.com/mrocklin?tab=overview&from=2018-07-01&to=2018-07-31
      </a>
</div>
      
    
<h1 style={{ margin: 0 }}
  className="Box-sc-g0xbh4-0 clYxDg prc-Heading-Heading-6CmGO"
  data-component="PH_Title"
  data-hidden="false"
><bdi className="Box-sc-g0xbh4-0 lhNOUb markdown-title" data-testid="issue-title">Serialization of data within a tensor is slow </bdi>

  <span className="Box-sc-g0xbh4-0 YJa-Di">
  <a href="https://github.com/pytorch/pytorch/issues/9168" target="_blank" rel="noopener noreferrer">
  #9168
    </a>
   
    </span>
</h1>

<div style={{ display: 'flex', alignItems: 'center' }}>
<a className="Box-sc-g0xbh4-0 cRhwji prc-Link-Link-85e08" 
href="https://github.com/mrocklin" data-hovercard-url="/users/stevengj/hovercard" data-testid="issue-body-header-author">mrocklin</a>

<div className="Box-sc-g0xbh4-0 bJQcYY ActivityHeader-module__footer--FVHp7"><span>opened</span>
<a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/pytorch/pytorch/issues/9168" 
data-testid="issue-body-header-link"><relative-time 
// sx="[object Object]" 
className="sc-aXZVg gcWyXp" 
datetime="2024-07-18T08:44:29.000Z" title="Jul 18, 2024, 2:14 PM GMT+5:30">on Jul 4, 2018</relative-time></a>

{/* <span className="MarkdownLastEditedBy-module__container--fKxHN"><span> · </span><span>edited by 
  <a className="Box-sc-g0xbh4-0 bjFvWy prc-Link-Link-85e08" href="https://github.com/stevengj">stevengj</a></span></span> */}

  </div>
</div>

<p>Here are the details of a specific PR from the <a href="https://github.com/pytorch/pytorch/issues/9168" target="_blank">pytorch/pytorch repository</a>:</p>

    </>
  );
};

export default MatthewRocklinPR_pytorch_pytorch_issues_9168_From_2018_7_01_To_2018_8_31;
